import { Track, TRACK_ID } from '@hugendubel/tracking_client';
import { Modal, Toaster } from '@hugendubel/react-basic';
import { WsBonusShopOrder } from '../ws/result/WsBonusShopOrder';
import { WS } from '../ws/WS';
import { Store } from '../store';
import { AppRoutes } from '../ui/appRoutes';
import { BonusPoints } from '../ui/BonusPoints';
import { externalHistory } from '../ui/hooks/useExposeNavigate';
import { ReducedProduct } from '../ws/result/ReducedProduct';

const ORDER_SYSTEM_CODE = process.env.IS_HUDU ? 'PR' : 'PE';

export const calculateBonusPoints = (points: BonusPoints, orderResult: WsBonusShopOrder) =>
    new BonusPoints(points.value - (orderResult.article.price.bonusCost ? orderResult.article.price.bonusCost : 0));

export const _OrderService = {
    finishOrder: (orderResult: WsBonusShopOrder) => {
        Store.set(({ points }) => ({
            points: calculateBonusPoints(points, orderResult),
            lastOrder: orderResult,
        }));
        externalHistory.navigate(AppRoutes.ORDER_CONFIRMATION);
    },
};

const delivery = (articleId: number, deliveryAddressId: string): Promise<void> =>
    WS.orderForDelivery({
        articleId,
        deliveryAddressId,
        orderSystemCode: ORDER_SYSTEM_CODE,
    })
        .then(_OrderService.finishOrder)
        .catch(error => {
            Track.error(
                TRACK_ID('2018-09-10 10:32:35'),
                'Unexpected error while ordering for delivery: ' + error.message
            );
            Toaster.open({ id: 'error.message.general' });
        });

const pickup = ({ articleId }: ReducedProduct): Promise<void> =>
    WS.orderForPickup({ articleId, orderSystemCode: ORDER_SYSTEM_CODE })
        .then(_OrderService.finishOrder)
        .then(Modal.close)
        .catch(error => {
            Track.error(
                TRACK_ID('2018-09-10 11:24:28'),
                'Unexpected error while ordering for pickup: ' + error.message
            );
            Toaster.open({ id: 'error.message.general' });
        });

export const OrderService = { pickup, delivery };
